import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import { EventDto } from "../../../types/eventTypes";

interface DeleteEventDialogProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => Promise<void>;
  event: EventDto;
}

/**
 * Dialog to confirm the deletion of an event. Warns the user that all information and participant data will be lost and that this action cannot be undone.
 * @param open - boolean to control whether the dialog is open or not
 * @param onClose - function to close the dialog
 * @param onDelete - function to delete the event
 * @param event - the event to be deleted, used to display the event name in the dialog
 * @returns DeleteEventDialog component
 */
const DeleteEventDialog = ({ open, onClose, onDelete, event }: DeleteEventDialogProps) => {
  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle>Dieses Event wirklich löschen?</DialogTitle>
      <DialogContent>
        Bist du dir sicher, dass du das Event <strong>{event.eventName}</strong> löschen möchtest? Alle Informationen
        und Teilnehmerdaten gehen dabei dauerhaft verloren.{" "}
        <strong>Dieser Schritt kann nicht rückgängig gemacht werden.</strong>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Abbrechen</Button>
        <Button color="error" variant="contained" onClick={onDelete}>
          Löschen
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteEventDialog;
